import React from 'react';
import './About.css'
import me from '../../images/me.jpg'
import Fade from 'react-reveal/Fade';
import { ProgressBar } from 'react-bootstrap';




const About = () => {
    return (
        <div id='about' className='main-about  mb-5'>
            <div className="row">
                <div className="container col-lg-12">
                    < small className='text-danger fs-4 fw-bold'> About Me</small >
                    <h2 className='section'>About Me
                    </h2>

                </div>
            </div>
            <div className="row">
                <div className="col-lg-5 col-md-12 col-sm-12">
                    <img className='w-75 img-fluid me' src={me} alt="" />
                </div>

                <div className="col-lg-7  col-md-12 col-sm-12">
                    <Fade right>
                        <div className='discrip'>
                            <h2 className='fs-1 fw-bold'>I'm Istiaque Ahmed</h2>
                            <h6 className='my-3'>WEB DEVELOPER <span className='text-danger'>||</span> FRONTEND DEVELOPER</h6>
                            <p className='desc my-3'> design and develop services for customers specializing creating stylish, modern websites, web services and online stores. My passion is to design digital user experiences through meaningful interactions. Check out my Portfolio</p>
                            <hr className='my-5' />
                            <h2 className='fs-1 fw-bold'>PERSONAL INFO
                            </h2>
                            <div className="row ">
                                <div className="col-lg-4  col-md-12 col-sm-12 my-3">
                                    <p><span className='desc'>Name :</span> Istiaque Ahmed</p>
                                    <p><span className='desc'>Age :</span> 25</p>
                                    <p><span className='desc'>Nationality :</span> Bangladeshi</p>
                                    <p><span className='desc'>Freelance  :</span> Available</p>

                                </div>
                                <div className="col-lg-4  col-md-12 col-sm-12 my-3">
                                    <p><span className='desc'>Address :</span> Mirpur,Dhaka</p>
                                    <p><span className='desc'>Phone :</span> +8801322308092</p>
                                    <p><span className='desc ml-2'>Email:</span>istiaqueahmed70@gmail.com</p>
                                    <p><span className='desc'>Languages :</span> English,Bengali</p>
                                </div>
                            </div>



                        </div>
                    </Fade>
                </div>

            </div>



            <div className=' col-lg-12 my-5'>
                <h2 className='section'>My Experience</h2>
                <h3 className='desc ms-5'>Skills</h3>


                <div className="row">


                    <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                        <span className='fw-bold text-white fs-4'>HTML5 <ProgressBar striped variant="success" animated now={85} /></span>

                    </div>

                    <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                        <span className='fw-bold text-white fs-4'>CSS3 <ProgressBar striped variant="warning" animated now={80} /></span>

                    </div>

                    <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                        <span className='fw-bold text-white fs-4'>BOOTSTRAP <ProgressBar striped variant="danger" animated now={90} /></span>

                    </div>

                    <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                        <span className='fw-bold text-white fs-4'>JAVASCRIPT <ProgressBar striped variant="secondary" animated now={80} /></span>
                    </div>

                </div>


                <div>
                    <div className="row">


                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>REACT <ProgressBar striped variant="success" animated now={90} /></span>

                        </div>

                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>NODE <ProgressBar striped variant="warning" animated now={75} /></span>

                        </div>

                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>MONGO <ProgressBar striped variant="danger" animated now={80} /></span>

                        </div>

                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>EXPRESS <ProgressBar striped variant="secondary" animated now={85} /></span>

                        </div>
                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>IllUSTRATOR <ProgressBar striped variant="success" animated now={85} /></span>

                        </div>
                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>MATERIAL UI <ProgressBar striped variant="warning" animated now={70} /></span>

                        </div>
                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>NETLIFY <ProgressBar striped variant="danger" animated now={90} /></span>

                        </div>
                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>GITHUB <ProgressBar striped variant="secondary" animated now={85} /></span>

                        </div>
                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>FIREBASE <ProgressBar striped variant="success" animated now={80} /></span>

                        </div>
                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>HEROKU <ProgressBar striped variant="warning" animated now={85} /></span>

                        </div>
                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>TAILWINDCSS <ProgressBar striped variant="danger" animated now={60} /></span>

                        </div>
                        <div className="col-lg-3  col-md-12 col-sm-12  my-2">
                            <span className='fw-bold text-white fs-4'>FIGMA <ProgressBar striped variant="secondary" animated now={80} /></span>

                        </div>
                    </div>
                </div>








            </div>



        </div >
    );
};

export default About;